/**
 * Option state type
 * @export
 * @enum {string}
 */
export var OptionStateType;
(function (OptionStateType) {
    OptionStateType["DEFAULT"] = "DEFAULT";
    OptionStateType["FILLING"] = "FILLING";
    OptionStateType["HOVER"] = "HOVER";
    OptionStateType["SELECTED"] = "SELECTED";
    OptionStateType["SELECTED_HOVER"] = "SELECTED_HOVER";
    OptionStateType["MULTIPLE_SELECTED"] = "MULTIPLE_SELECTED";
    OptionStateType["MULTIPLE_SELECTED_HOVER"] = "MULTIPLE_SELECTED_HOVER";
    OptionStateType["DISABLED"] = "DISABLED";
    OptionStateType["FOCUS"] = "FOCUS";
})(OptionStateType || (OptionStateType = {}));
//# sourceMappingURL=state.js.map